<template>
  <f-toast-base>
    <div class="icon" v-if="icon">
      <f-icon class="s24" :icon="icon"></f-icon>
    </div>
    <div class="message">
      <slot></slot>
    </div>

    <div class="separator" v-if="$slots.action || $slots.iconAction"></div>
    <div class="action" v-if="$slots.action">
      <f-button type="tertiary overlay" @click="$emit('action')">
        <slot name="action"> </slot>
      </f-button>
    </div>
    <div class="action" v-if="$slots.iconAction">
      <f-button type="tertiary overlay icon" @click="$emit('action')">
        <slot name="iconAction"> </slot>
      </f-button>
    </div>
  </f-toast-base>
</template>
<script>
export default {
  props: ["icon"],
  computed: {
  },
};
</script>
<style lang="scss">
.f-toast {
  gap: 16px;

  .separator {
    align-self: stretch;
    width: 1px;
    opacity: 0.25;
    margin: -8px 0;
    /* White / 50% */
    background-color: rgba(255, 255, 255, 0.5);
  }

  .action {
    .f-button {
      height: 38px;
    }
    .f-icon {
      color: rgba(255, 255, 255, 0.75);
    }
  }

    &.warning .icon {
      color: var(--statusNotice);
    }
}
</style>